<template>
    <div class="register_wrap">
        <div class="main_wrap">
            <div class="register_title mat20"><i class="el-icon-user-solid">&nbsp;账户基本信息</i></div>
            <!-- 修改信息表单 -->
            <el-form class="register flex-center" :model="regForm" :rules="regRules" ref="regForm" label-width="130px">
                <div class="line">
                    <el-form-item prop="username" label="用户名:">
                        <div class="flex-between">
                            <el-input v-model="regForm.username" placeholder="请输入用户名"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="gender" label="性别:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.gender" placeholder="选择性别">
                                    <el-option v-for="item in genderList" :label="item.type" :value="item.id" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="birthday" label="出生年月:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-date-picker class="date-picker" v-model="regForm.birthday" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"  clearable></el-date-picker>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="roleId" label="身份:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-input v-model="roleIdName" disabled></el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="educationalLevel" label="教育层次:" v-if="regForm.roleId != teacherId && regForm.roleId != wokerId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.educationalLevel" placeholder="选择教育层次" @change="selectEduTcth()">
                                    <el-option v-for="item in educationalLevelList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="teachingLevel" label="教学层次:" v-if="regForm.roleId == teacherId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.teachingLevel" placeholder="选择教学层次" @change="selectEduTcth()">
                                    <el-option v-for="item in teachingLevelList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workArea" label="工作领域:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.workArea" placeholder="选择工作领域">
                                    <el-option v-for="item in workAreaList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="flex-between school_wrap" v-if="regForm.roleId != wokerId">
                        <el-form-item prop="provinceId" label="学校:">
                            <div class="flex-between">
                                <el-select v-model="regForm.provinceId" disabled  placeholder="选择省份" @change="getCityList()">
                                    <el-option v-for="item in provinceListL" :label="item.provinceName" :value="item.provinceId" :key="item.provinceId"></el-option>
                                </el-select>
                                <el-select v-model="regForm.cityId" disabled  placeholder="选择城市" @change="getSchoolList()">
                                    <el-option v-for="item in cityList" :label="item.cityName" :value="item.cityId" :key="item.cityId"></el-option>
                                </el-select>
                                <el-select v-model="regForm.schoolId" disabled  placeholder="选择学校">
                                    <el-option v-for="item in schoolList" :label="item.name" :value="item.id" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="flex-between" v-if="regForm.roleId == wokerId">
                        <el-form-item prop="provinceId" label="工作城市:">
                            <div class="flex-between">
                                <el-select v-model="regForm.provinceId" placeholder="选择省份" @change="getCityList()">
                                    <el-option v-for="item in provinceListL" :label="item.provinceName" :value="item.provinceId" :key="item.provinceId"></el-option>
                                </el-select>
                                <el-select v-model="regForm.cityId" placeholder="选择城市" >
                                    <el-option v-for="item in cityList" :label="item.cityName" :value="item.cityId" :key="item.cityId"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item prop="collegeType" label="二级学院/系部:" v-if="isShowCollegeMAjor">
                        <div class="flex-between">
                            <el-input v-model="regForm.collegeType" placeholder="请输入二级学院/系部"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workUnit" label="工作单位:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <el-input v-model="regForm.workUnit" placeholder="请输入工作单位"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="major" label="专业:" v-if="isShowCollegeMAjor">
                        <div class="flex-between">
                            <el-input v-model="regForm.major" placeholder="请输入专业"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workDepartment" label="工作部门:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <el-input v-model="regForm.workDepartment" placeholder="请输入工作部门"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="researchDirection" label="研究方向:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.researchDirection" placeholder="选择研究方向">
                                    <el-option v-for="item in researchDirectionList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="academicTile" label="职称:" v-if="regForm.roleId == teacherId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.academicTile" placeholder="选择研究方向">
                                    <el-option v-for="item in academicTileList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="academicName" label="职称:" v-if="regForm.academicTile == '其它'">
                        <el-input v-model="regForm.academicName" placeholder="请输入职称"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <!-- 修改密码、绑定电话 -->
            <div class="change_phone">
                <div class="mab20"><i class="el-icon-lock">&nbsp;账号安全</i></div>
                <!-- 绑定手机 -->
                <div class="flex-between mab20" v-if="!regForm.phone">
                    <span style="width:200px;">手机号码：</span>
                    <el-input v-model="clockPhone" placeholder="请输入手机号" type="number" maxlength="11" disabled></el-input>
                    <el-button plain type="primary" @click="bindingPhone('new')">绑定手机号</el-button>
                </div>
                <!-- 换绑手机 -->
                <div class="flex-between mab20" v-else>
                    <span style="width:200px;">手机号码：</span>
                    <el-input v-model="regForm.phone" placeholder="请输入手机号"  disabled></el-input>
                    <el-button plain type="primary" @click="bindingPhone('change')">换绑手机号</el-button>
                </div>
                <div class="mab20 tips" v-if="!regForm.phone"><i class="iconfont icon-gantanhao"></i>&nbsp;&nbsp;&nbsp;<span>绑定手机号后能够通过手机号登录平台，也可在忘记密码时帮助密码找回。</span></div>
                <div class="flex-between">
                    <p>登录密码：</p>
                    <el-button plain type="primary" @click="pwdShow = true">修改密码</el-button>
                </div>
            </div>
            <!-- 按钮 -->
            <div class="footer_btn">
                <el-button type="primary" @click="updateUserInfo">保存修改</el-button>
            </div>
        </div>
        <!-- 绑定手机与换绑手机弹窗 -->
        <el-dialog :visible.sync="tipsShow" width="25%" top="10%" center class="dialog2" @close="clearContent">
            <div class="tips_wrap">
                <el-steps  :active="activeItem" align-center>
                    <el-step title="身份确认"></el-step>
                    <el-step :title="binding"></el-step>
                    <el-step title="绑定成功"></el-step>
                </el-steps>
            </div>
           <div v-if="activeItem == 1">
               <el-input class="mat20" v-model="loginPwd" show-password placeholder="请输入该账号的登录密码"></el-input>
               <div class="btn_wrap"><el-button type="primary" @click="submitPwd">提交</el-button></div>
           </div>
           <div v-if="activeItem == 2">
               <el-input class="mat20" v-model="loginPhone" type="number" placeholder="请输入手机电话号码"></el-input>
               <div class="mat20 flex-between">
                   <el-input v-model="verifycontent" placeholder="请输入图形验证码"></el-input>
                   <div>
                       <div @click="getverifyCode"><img :src="verifyCodeUrl" style="cursor: pointer;" title="看不清？换一张"/></div>
                   </div>
               </div>
               <div class="mat20 flex-between">
                   <el-input v-model="mobileVerify" placeholder="请输入手机验证码"></el-input>
                    <el-button type="primary" @click="submitCode"  v-if="!isabled">获取验证码</el-button>
                    <el-button type="info" plain v-else disabled>{{timer}}(s)后获取</el-button>
               </div>
               <div class="btn_wrap"><el-button type="primary" @click="submitPhone">提交</el-button></div>
           </div>
           <div class="title" v-if="activeItem == 3">
                <div class="icont mat40"><i class="iconfont icon-chenggong"></i></div>
                <div class="title_tips mat40">{{bindingSuccese}}</div>
                <div class="btn_wrap"><el-button type="primary" @click="tipsShow = false">确定</el-button></div>
            </div>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog :visible.sync="pwdShow" width="25%" top="10%" center class="dialog2" @close="resetRegForm = {}">
            <div class="tips_wrap pwd_header">
                <i class="iconfont icon-xiugaimima"></i>&nbsp;&nbsp;&nbsp;<span>修改密码</span>
            </div>
            <div class="register" v-if="!isSuccess">
                <el-form :model="resetRegForm" :rules="resetRegRules" ref="resetRegForm" label-width="120px">
                    <el-form-item prop="oldPassword" label="原密码:">
                        <el-input v-model="resetRegForm.oldPassword" show-password placeholder="请输入原密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="newPassword" label="新密码:">
                        <el-input v-model="resetRegForm.newPassword" show-password placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="confirmPassword" label="确认密码:">
                        <el-input v-model="resetRegForm.confirmPassword" show-password placeholder="请确认密码"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="title" v-else>
                <div class="icont mat40"><i class="iconfont icon-chenggong"></i></div>
                <div class="title_tips mat40 mab20">您的账号密码重置成功！</div>
            </div>
             <div class="footer_btn_save">
                <el-button type="primary" @click="sureChangePwd">确定</el-button>
            </div>
        </el-dialog>
        <!-- 重置密码 -->
        <el-dialog  :visible.sync="resetDefPwdShow" width="28%" top="10%" center class="dialog2" :close-on-click-modal="false">
            <div class="pwd_def">
                <div class="mab20">重置密码</div>
                <el-form class="register" :model="resetForm" :rules="resetRules" ref="resetForm" label-width="120px">
                    <div class="form_wrap flex-column-between">
                        <el-form-item prop="password" label="新密码:">
                            <el-input placeholder="请输入新密码" v-model="resetForm.password" show-password></el-input>
                        </el-form-item>
                        <el-form-item prop="rePassword" label="再次输入:">
                            <el-input placeholder="请再次输入密码" v-model="resetForm.rePassword" show-password></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="mat25">
                    <el-button type="primary" @click="toResetPwd">确认重置</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getSchoolById,listWithKeyword,getProvince,getCity,getSchool,checkAndSendSMS,checkOldPassword,bindOrUpdatePhone,updatePassword,getInfo,updateUser,getImage,updateDefaultPwd} from '../../../utils/api'
import {genderList,educationalLevelList,teachingLevelList,researchDirectionList,workAreaList,academicTileList} from '../../../utils/commonData'
export default {
    data () {
        return {
            // 全局定义老师学生id，防止修改
            studentId:1,
            teacherId:2,
            wokerId:3,
            clockPhone:'——  ——',
            tipsShow:false,
            pwdShow:false,
            isSuccess:false,
            resetDefPwdShow:Boolean(this.$store.state.isDefaultPassword),
            loginPwd:'',
            loginPhone:'',
            mobileVerify:'',
            activeItem:1,
            verifyCodeUrl:'',
            verifycontent:'',
            binding:'',
            bindingSuccese:'',
            isShowCollegeMAjor:false,  //教学教育层次为小初高和角色为在职人员则不展示二级学院和专业
            roleIdName:'',
            uuId1:'',  //密码验证
            uuid2:'',  //验证码验证
            isabled:false,
            timer:60,
            // 性别选择
            genderList:JSON.parse(JSON.stringify(genderList)),
            // 教育层次（学生、待岗、退休）
            educationalLevelList:JSON.parse(JSON.stringify(educationalLevelList)),
            // 教学层次（老师）
            teachingLevelList:JSON.parse(JSON.stringify(teachingLevelList)),
            // 研究方向
            researchDirectionList:JSON.parse(JSON.stringify(researchDirectionList)),
            // 工作领域（在职人员）
            workAreaList:JSON.parse(JSON.stringify(workAreaList)),
            // 职称（教师）
            academicTileList:JSON.parse(JSON.stringify(academicTileList)),
             // 表单对象
            regForm:{
                username:'',
                gender:1,
                birthday:'',
                roleId:'',
                educationalLevel:'',
                teachingLevel:'',
                provinceId:'',
                cityId:'',
                schoolId:'',
                schoolName:'',
                collegeType:'',
                major:'',
                researchDirection:'',
                academicTile:'',
                workArea:'',
                workUnit:'',
                workDepartment:'',
            },
            // 修改密码
            resetRegForm:{
                oldPassword:'',
                newPassword:'',
                confirmPassword:''
            },
            resetRegRules:{
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次确认密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
            },
            // 校验规则
            regRules:{
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
                birthday: [{ required: true, message: '请输入出生年月', trigger: 'blur' }],
                educationalLevel: [{ required: true, message: '请选择教育层次', trigger: 'blur' }],
                teachingLevel: [{ required: true, message: '请选择教学层次', trigger: 'blur' }],
                provinceId: [{ required: true, message: '请选择学校所在省', trigger: 'blur' }],
                cityId: [{ required: true, message: '请选择学校所在市', trigger: 'blur' }],
                schoolId: [{ required: true, message: '请选择所在学校', trigger: 'blur' }],
                schoolName: [{ required: true, message: '请选择所在学校', trigger: 'blur' }],
                collegeType:[{ required: true, message: '请填写所在学院/系', trigger: 'blur' }],
                major:[{ required: true, message: '请选择所在专业', trigger: 'blur' }],
                researchDirection:[{ required: true, message: '请选择研究方向', trigger: 'blur' }],
                academicTile:[{ required: true, message: '请选择职称', trigger: 'blur' }],
                workArea:[{ required: true, message: '请选择工作领域', trigger: 'blur' }],
                workUnit:[{ required: true, message: '请选择工作单位', trigger: 'blur' }],
                workDepartment:[{ required: true, message: '请选择工作部门', trigger: 'blur' }],
            },
            // 重置密码修改密码
            resetForm:{
                password:'',
                rePassword:''
            },
            resetRules:{
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                rePassword: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
            },
            provinceListL:[],
            cityList:[],
            schoolList:[]
        }
    },
    computed:{},
    created(){
        this.getUserList()
    },
    methods:{
        //重置密码修改
        toResetPwd(){
            let { password , rePassword } = this.resetForm
            if(password != rePassword){
                return this.$message.error('密码输入不一致')
            }
            updateDefaultPwd({ newPassword : this.resetForm.password }).then(res => {
                this.$core.logout()
            }).catch(err => {})
        },

        // 教学教育层次改变
        selectEduTcth(){
            let { teachingLevel, educationalLevel, roleId } = this.regForm
            this.isShowCollegeMAjor = this.$core.isShowCollegeMAjor(teachingLevel, educationalLevel,roleId)
        },

        // 根据角色取消校验
        chancelValidate(){
            // 取消校验
            let studentArr = ["major","researchDirection"] //学生
            let teacherArr = ["major","researchDirection","academicTile"] //老师
            let workerArr = ["workUnit","workDepartment","researchDirection"] //在职人员
            let otherArr = ["major","collegeType","researchDirection","provinceId","cityId","schoolId"]  //待岗、退休

            // 表单所有键key
            let totalRulesArr = Object.keys(this.regRules)

            // 判断前先将校验规则（是否校验）回归
            totalRulesArr.forEach(item => {
                this.regRules[item][0].required = true
            }) 
            switch(this.regForm.roleId){
                // 学生
                case 1:
                    studentArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    break;
                // 老师
                case 2:
                    teacherArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    break;
                // 在职
                case 3:
                    workerArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    break;
                // 待岗、退休
                case 4:
                case 5:
                    otherArr.forEach(item => {
                         this.regRules[item][0].required = false
                    })
                    break;
            }
        },

        // 获取用户信息
        getUserList(){
            getInfo().then(res => {
                this.regForm = Object.assign({},res.data)
                this.selectEduTcth()
                this.roleIdName = this.$core.roleName(this.regForm.roleId)
                //为避免不必要麻烦，这里学校选择框渲染的是字段schoolName,对数据做出处理
                this.schoolList = []
                let obj = {}
                obj.id = this.regForm.schoolId
                obj.name = this.regForm.schoolName
                this.schoolList.push(obj)
                this.regForm.provinceId && this.getProvinceList()
                this.chancelValidate()
            }).catch(err => {})
        },

        //绑定手机清空输入框
        clearContent(){
            this.loginPwd = ''
            this.loginPhone = ''
            this.verifycontent = ''
            this.mobileVerify = ''
        },

        // 获取图形验证码
        getverifyCode(){
            getImage().then(res => {
                this.verifyCodeUrl = res.data.image
                this.uuid2 = res.data.uuid_verify
            }).catch(err =>　{})
        },

        // 提交图形验证码并发送手机验证码
        submitPwd(){
            if(!this.loginPwd){
                return this.$message.error('请先输入账号登录密码')
            }
            checkOldPassword({oldPassword : this.loginPwd}).then(res => {
                this.uuId1 = res.data
                this.activeItem = 2
                this.getverifyCode()
            }).catch(err => {})
        },

        // 提交图形验证码并发送手机验证码
        submitCode(){
            if(!this.loginPhone || !this.verifycontent){
                return this.$message.error('请先输入手机号与图形验证码')
            }
            checkAndSendSMS(`${this.loginPhone}/${this.verifycontent}/${this.uuid2}`).then(res => {
                this.$message.success('验证通过，请查收手机验证码')
                // 手机验证码发送成功后禁用
                let interval = setInterval(() => {
                    let obj =  this.$core.virifyCode(this.timer)
                    this.timer = obj.timer
                    this.isabled = obj.isabled
                    if(!obj.isabled){
                        this.timer = 60
                        clearInterval(interval)
                    }
                },1000)
            }).catch(err => {
                this.getverifyCode()
            })
        },

        // 前往绑定手机号
        bindingPhone(status){
            this.tipsShow = true
            this.activeItem = 1
            switch(status){
                case "new":
                    this.binding = '绑定手机'
                    this.bindingSuccese = '您的账号手机号绑定成功'
                break;
                case "change":
                    this.binding = '换绑手机'
                    this.bindingSuccese = '您的账号手机号换绑成功'
                break;
            }
        },

        // 手机号和验证码
        submitPhone(){
            bindOrUpdatePhone(`${this.loginPhone}/${this.mobileVerify}/${this.uuId1}`).then(res => {
                this.activeItem = 3
                this.clearContent()
                this.getUserList()
            }).catch(err => {})
        },

        // 确认修改密码
        sureChangePwd(){
            if (this.isSuccess){
                this.pwdShow = false
                this.isSuccess = false
            }else{
                this.$refs.resetRegForm.validate(valid => {
                    if(!valid) return
                    if(this.resetRegForm.newPassword != this.resetRegForm.confirmPassword){
                        return this.$message.error('两次密码输入不一致!')
                    }
                    updatePassword(this.resetRegForm).then(res => {
                        this.isSuccess = true
                        this.resetRegForm = {}
                    }).catch(err => {})
                })
            }
        },

        // 获取省份
        getProvinceList(){
            getProvince().then(res => {
                this.provinceListL = res.data
                this.regForm.provinceId && this.getCityList()
            }).catch(err => {})
        },

        // 获取城市列表
        getCityList(){
            getCity(`${this.regForm.provinceId}`).then(res => {
                this.cityList = res.data
                this.regForm.cityId && this.getSchoolList()
            }).catch(err => {})
        },

        //获取学校列表
        getSchoolList(){
            getSchool(`${this.regForm.provinceId}/${this.regForm.cityId}`).then(res => {
                this.schoolList = res.data
            }).catch(err => {})
        },

        //修改用户信息
        updateUserInfo(){
            // 如果职称有内容且选择“其它”时，将输入框的值(academicName)赋予(academicTile)
            this.regForm.academicTile = this.regForm.academicName ? this.regForm.academicName : this.regForm.academicTile
            this.$refs.regForm.validate(valid => {
                if(!valid) return
                updateUser(this.regForm).then(res => {
                    this.$message.success('修改成功!')
                }).catch(err => {})
            })
        }
    }
}
</script> 

<style lang='scss' scoped>
.pwd_def{
    text-align: center;
}
.footer_btn_save{
    text-align: center;
}
.register{
    text-align: center;
    // width: 100%;
    // background: black;
}
.tips{
    color: red;
    font-size: 14px;
}
.title{
    text-align: center;
    font-size: 20px;
}
.icon-chenggong{
    font-size: 30px;
}
.pwd_header{
    font-size: 18px;
}
.dialog2{
    /deep/ .el-dialog{
        // height: 35%;
        display: flex;
        align-items: center;
        .tips_wrap{
            width: 360px;
            text-align: center;
            margin-bottom: 30px;
            padding-top: 20px;
        }
        .btn_wrap{
            text-align: center;
            margin-top: 20px;
            width: 100%;
            /deep/ .el-button{
                width: 50%;
                position: absolute;
                bottom: 20px;
                left: 25%;
            }
        }
    }
    
}
.register_wrap{
    height: 100vh;
    width: 100%;
    background: url(../../../assets/img/personal.png) 0 0/100% 100% no-repeat;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .main_wrap {
        width: 100%;
        height: calc(90vh - 100px);
        padding-bottom: 100px;
        overflow-y: auto;
        // background: #fff;
        .register_title{
            text-align: center;
            margin-bottom: 40px;
            font-size: 20px;
            i{
                color: #5277F7;
                font-size: 34px;
                font-weight: bold;
            }
        }
        .change_phone{
            width: 30%;
            margin:50px 0 60px 35%;
            padding: 50px;
            background: #F6F6F6;
            .el-icon-lock{
                color: #5277F7;
                font-size: 22px;
                font-weight: bold;
            }
        }
        .line{
            width: 40%;
            margin-left: 30%;
            .label{
                width: 33%;
                color: #fff;
                font-size: 16px;
            }
            .select_label{
                width: 100%;
            }
            .date-picker{
                width: 100% ;
            }
        }
        .footer_btn{
            width: 60%;
            margin-left: 20%;
            margin-top: 60px;
            text-align: center;
            /deep/ .el-button{
                width: 20%;
            }
        }
    }
}
</style>